<table border="1">
    <thead>
        <tr>
            <th>Unique identifier</th>
            <th>Title</th>
            <th>Description</th>
            <th>Specialty</th>
        </tr>
    </thead>
    <tbody>
        <tr>
            <th>{{ indication?.indicationIdentifier }}</th>
            <th>{{ indication?.title }}</th>
            <th>{{ indication?.description }}</th>
            <th>{{ indication?.indicationSpecialty }}</th>
        </tr>
    </tbody>
</table>
